/**
 * Brushfire Design System — Theme 1 (Figma: `fN0WVjC2MeO36uJzvjSYos`, root `1:2` “Theme 1”).
 * https://www.figma.com/design/fN0WVjC2MeO36uJzvjSYos/Brushfire-D.System?node-id=1-2
 *
 * Use for raw `sx` / constants; prefer `useTheme().palette` where components already have theme access.
 */

/** Figma Theme 1 — B.Primary 1 */
export const palettePrimaryMain = '#008CD0'
export const palettePrimaryDark = '#0077B3'
export const palettePrimaryLight = '#4DB8E8'

/** Muted surface tint that pairs with the blue primary (selection / chips). */
export const palettePrimaryMutedSurface = '#E6F5FC'

export const paletteSecondaryInk = '#0F172A'

export const paletteAccentMain = '#0FD4FC'

export const paletteSuccessMain = '#10B981'
export const paletteErrorMain = '#EF4444'
export const paletteWarningMain = '#F59E0B'
export const paletteInfoMain = '#3B82F6'

/** Page / app canvas (Figma Theme 1 background). */
export const surfaceBackground = '#FFFFFF'
/** Cards, panels, elevated surfaces. */
export const surfacePaper = '#F8FAFC'
export const borderDefault = '#E2E8F0'

export const textPrimary = '#0F172A'
export const textSecondary = '#64748B'
export const textDisabled = '#94A3B8'
